import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';

class Searchcontainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const getSearchContent = getContent('staticContent');
    const country = (this.props.country).toLowerCase();
    return (
      <div id = "search-container" className="searchContainer">
        <form action={`/${country}/brc/search`} method="GET" name="search-field"
          id="form-search">
            <div className="vx_form-group search">
            <div className="vx_form-control vx_form-control_complex groupbrc vx_form-group_hiddenLabel">
                <label htmlFor="mysearch" className="vx_form-group_hiddenLabel">
                {'Search the Business Resource Center'}</label>
                <input type="text" name= "q" id="mysearch" autoComplete="off"
                  className="vx_text-body search-value form-control vx_form-control"
                  placeholder={getSearchContent('brc.searchPlaceholder')} required />
                <div className="vx_form-control-icon brcsearch-icon">
                <button className = "search-btn hide-text" type="submit" data-pa-click="brcSearchClick"
                  ><span aria-hidden = "true" className="icon icon-small vx_icon-magnifying-glass"/>
                {'Submit search'}</button>
                </div>
            </div>
            </div>
        </form>
      </div>
    );
  }
  }

export default Searchcontainer;
Searchcontainer.propTypes = {
  country: PropTypes.string
};
